// extracted by mini-css-extract-plugin
module.exports = {"title":"title-706be910"};